import ExpenseType from "./ExpenseType";

export default ExpenseType;
